import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitGetSmerList = {
  user: string;
  offset: number;
};

export type ComparisonItem = {
  id: string;
  score: number;
  text: string;
};

export type Emotion = {
  name: string;
  value: number;
};

export type Comparison = {
  againstScore: number;
  commonScore: number;
  forScore: number;
  comparisonFor: ComparisonItem[];
  comparisonAgainst: ComparisonItem[];
};

export type SMER = {
  id: string;
  text: string;
  textBin?: string;
  eventBin?: string;
  thoughtsBin?: string;
  behaviourBin?: string;
  feelInBodyBin?: string;
  solutionBin?: string;
  conclusionBin?: string;
  comparisonBin?: string;
  filled: number;
  emotions: Emotion[];
  creationDate: string;
};

export type ResponseGetSmerList = SMER[];

export const getSmerList = async (data: SubmitGetSmerList) => {
  const response = await axios.get(`${rootUrl}/psychologist/smer/list`, {
    params: {
      user: data.user,
      offset: data.offset,
      token: getCookies('auth'),
    },
    headers: {
      'Cache-Control': 'no-store',
    },
  });

  return response.data;
};
